import * as mock from './mock';

export const InitialMockData = {
  onboarding: { id: 'onboarding', value: true },
  organization: mock.organization,
  userByOrganization: mock.userByOrganization,
  brand: mock.brand,
  adAccountElement: mock.adAccountElement,
};

export type KeysMockData = keyof typeof InitialMockData;
